import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';

class AboutRouteComponent extends Component {
  <template>
    {{#each @model.recentArticles as |article|}}
      <h1>{{article.title}}</h1>
    {{/each}}
  </template>
}
export default RouteTemplate(AboutRouteComponent);
